import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useTariffsWorkplaceState } from './Tariffs';

type TariffsAddButtonProps = {
    showModal: () => void;
};

const TariffsAddButton = ({ showModal }: TariffsAddButtonProps) => {
    const { setSelectedItem: setCurrentItem } = useTariffsWorkplaceState();

    return (
        <DropdownFilterButton
            onClick={() => {
                setCurrentItem(null);
                showModal();
            }}
            icon={faPlus}
            disabled={false}
            title="BackOfficeAdd"
        />
    );
};

export default TariffsAddButton;
